// extracted by mini-css-extract-plugin
module.exports = {"section":"PromoAma_section__cy4Er","streamerAvatar":"PromoAma_streamerAvatar__dlNw_","title":"PromoAma_title__Mzjno","text":"PromoAma_text__S4hiT"};